import registerReducer from './registerReducer';
export default registerReducer;